export default __webpack_public_path__ + "static/media/SWT1380.34I-35070_-23153_0.6f270163.jpg";